import React, { createContext, useMemo, ReactElement, useContext } from 'react';
import { Option } from 'fp-ts/lib/Option';
import { CriteriaCallback, useCase, UseCaseDispatch, UseCaseState } from 'adapter/in/common/hooks/useCase';
import Location from 'domain/entity/location';
import { ReadLocation } from 'use-case/location/readLocationUseCase';

export type LocationState = UseCaseState & { location: Option<Location> };

export const LocationStateContext = createContext({} as LocationState);
export const useLocation = (): LocationState => useContext(LocationStateContext);

type LocationDispatch = UseCaseDispatch & { read: CriteriaCallback };

const LocationDispatchContext = createContext({} as LocationDispatch);
export const dispatchLocation = (): LocationDispatch => useContext(LocationDispatchContext);

type LocationProviderProps = {
    getLocation: ReadLocation;
    children: ReactElement;
};
export const LocationProvider = (props: LocationProviderProps): ReactElement => {
    const { children, getLocation } = props;
    const { isLoading, data, error, setLoading, setData, setError, execute } = useCase(getLocation, false);
    const valueLocationState = useMemo(() => ({ isLoading, location: data, error }), [isLoading, data, error]);
    const valueLocationDispatch = useMemo(
        () => ({
            setLoading,
            setError,
            read: execute,
        }),
        [setLoading, setData, setError]
    );
    return (
        <LocationStateContext.Provider value={valueLocationState}>
            <LocationDispatchContext.Provider value={valueLocationDispatch}>{children}</LocationDispatchContext.Provider>
        </LocationStateContext.Provider>
    );
};
